import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { selector as authStoreSelector } from "../../store/AuthStore";

import { drawerItems } from "./DrawerItems";
import useStyles from "./useStyles";

/**
 * メニュードロワーコンポーネント.
 *
 * @return {object} コンポーネント
 */
function MenuDrawer() {
  const {
    // リモート保守可能フラグ（true: 可能、false: 不可能）
    isRemoteMaintenance,
    // ファイル一覧メニュー表示フラグ（true: 表示、false: 非表示）
    isDisplayFilesMenu,
    // 工番管理メニュー表示フラグ（true: 表示、false: 非表示）
    isDisplayPressManagementMenu,
  } = useSelector(authStoreSelector);

  // スタイル
  const styles = useStyles();

  // Location情報
  const location = useLocation();

  // 上位階層のパス名を取得（例："/hoge/fuga" -> "hoge"）
  const pathName = location.pathname.split("/")[1];

  return (
    <>
      <div className={styles.toolbar} />
      <List disablePadding>
        <ListSubheader>ドキュメント</ListSubheader>
        {isDisplayFilesMenu && (
          <Link
            className={styles.link}
            key={drawerItems.files.id}
            to={drawerItems.files.path}
          >
            <ListItem button selected={pathName === drawerItems.files.id}>
              <ListItemIcon className={styles.listItemIcon}>
                {drawerItems.files.icon}
              </ListItemIcon>
              <ListItemText primary={drawerItems.files.name} />
            </ListItem>
          </Link>
        )}
        <Link
          className={styles.link}
          key={drawerItems.register.id}
          to={drawerItems.register.path}
        >
          <ListItem button selected={pathName === drawerItems.register.id}>
            <ListItemIcon className={styles.listItemIcon}>
              {drawerItems.register.icon}
            </ListItemIcon>
            <ListItemText primary={drawerItems.register.name} />
          </ListItem>
        </Link>
        <Divider />
        <ListSubheader>データ</ListSubheader>
        <Link
          className={styles.link}
          key={drawerItems.dataGraph.id}
          to={drawerItems.dataGraph.path}
        >
          <ListItem button selected={pathName === drawerItems.dataGraph.id}>
            <ListItemIcon className={styles.listItemIcon}>
              {drawerItems.dataGraph.icon}
            </ListItemIcon>
            <ListItemText primary={drawerItems.dataGraph.name} />
          </ListItem>
        </Link>
        <Link
          className={styles.link}
          key={drawerItems.report.id}
          to={drawerItems.report.path}
        >
          <ListItem button selected={pathName === drawerItems.report.id}>
            <ListItemIcon className={styles.listItemIcon}>
              {drawerItems.report.icon}
            </ListItemIcon>
            <ListItemText primary={drawerItems.report.name} />
          </ListItem>
        </Link>
        <Divider />
        <ListSubheader>管理</ListSubheader>
        {isRemoteMaintenance && (
          <>
            <Link
              className={styles.link}
              key={drawerItems.remoteMaintenance.id}
              to={drawerItems.remoteMaintenance.path}
            >
              <ListItem
                button
                selected={pathName === drawerItems.remoteMaintenance.id}
              >
                <ListItemIcon className={styles.listItemIcon}>
                  {drawerItems.remoteMaintenance.icon}
                </ListItemIcon>
                <ListItemText primary={drawerItems.remoteMaintenance.name} />
              </ListItem>
            </Link>
          </>
        )}
        {isDisplayPressManagementMenu && (
          <Link
            className={styles.link}
            key={drawerItems.pressManagement.id}
            to={drawerItems.pressManagement.path}
          >
            <ListItem
              button
              selected={pathName === drawerItems.pressManagement.id}
            >
              <ListItemIcon className={styles.listItemIcon}>
                {drawerItems.pressManagement.icon}
              </ListItemIcon>
              <ListItemText primary={drawerItems.pressManagement.name} />
            </ListItem>
          </Link>
        )}
      </List>
    </>
  );
}

export default MenuDrawer;
